import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Const from 'constants';
import {SearchRuleBuilder as RuleBuilder} from 'services/search-rule-builder';
import {filterUsedPlayers} from 'components/molecules/filter-lineups-by-player/helpers';
import {
    calcPlayerExposure,
    getPlayerLineupsQuantityPropName,
    isPlayerUsedInLineups,
} from 'components/organisms/used-players-list/helpers';
import DisabledPlayerIfGameLockedSpecification from 'specifications/disabled-player-if-game-locked-specification';
import {generateRandomKey} from 'helpers/hash';
import DisabledPlayerIfGameInactiveSpecification from 'specifications/disabled-player-if-game-inactive-specification';

class PlayersList extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = {};
        this.state = {};
    }

    getActualValue(player, param) {
        let value = player[param];
        if (this.isValueBeingChanged[param] && player.playerId in this.state[param]) {
            value = this.state[param][player.playerId];
        }

        return value;
    }

    getRenderKey() {
        return generateRandomKey();
    }

    isRankMode(playersType) {
        return inArray(playersType, [Const.CAPTAIN_MODE, Const.STAR_MODE, Const.PRO_MODE, Const.FLEX_MODE]);
    }

    getSearchRuleByPosition() {
        const {filters} = this.props;

        return RuleBuilder.inArr('position', filters.position.getValue(), (item) => parseInt(item));
    }

    getSearchRuleByFlexPosition() {
        return RuleBuilder.callback('usedInLineupsAsFlex', (player) => player.usedInLineupsAsFlex > 0);
    }

    getSearchRuleBySuperFlexPosition() {
        return RuleBuilder.callback('usedInLineupsAsSuperFlex', (player) => player.usedInLineupsAsSuperFlex > 0);
    }

    getSearchRuleByLineupRole() {
        const {filters} = this.props;

        return RuleBuilder.inArr('lineupRole', filters.position.getValue());
    }

    getSearchRuleByFlexPositionInLineup() {
        return RuleBuilder.equal('positionIdInLineup', 'flex');
    }

    getFilteredUsedPlayers() {
        const {usedPlayers, filterLineupsByPlayer, filters} = this.props;

        const filteredPlayers = filterUsedPlayers(usedPlayers, filterLineupsByPlayer);

        if (filters.isShowUnexposedPlayersEnabled()) {
            return filteredPlayers;
        }

        return filteredPlayers.filter((player) => isPlayerUsedInLineups(player, filters.position));
    }

    calcPlayerExposure(player) {
        const {filterLineupsByPlayer, lineups, filters} = this.props;
        const propName = getPlayerLineupsQuantityPropName(filters.position);

        return calcPlayerExposure(player[propName], filterLineupsByPlayer, lineups);
    }

    calcPlayerLineupsQuantity(player) {
        const {filters} = this.props;
        const propName = getPlayerLineupsQuantityPropName(filters.position);

        return player[propName];
    }

    getRowClassName(player) {
        const {sportConfig, games = {}} = this.props;

        if (DisabledPlayerIfGameLockedSpecification.isSatisfiedBy({sportConfig, games, player})) {
            return 'disabled-player';
        }

        if (DisabledPlayerIfGameInactiveSpecification.isSatisfiedBy({sportConfig, games, player})) {
            return 'inactive-game';
        }

        return '';
    }

    getPlayerExposureView(player) {
        return (
            <td className="text-blue nowrap">
                {'lateSwapLineupsUsage' in player ? (
                    <span className="text-dark-red">{player.lateSwapLineupsUsage.getPercentage()}% </span>
                ) : null}
                {`${this.calcPlayerExposure(player)}% (${this.calcPlayerLineupsQuantity(player)})`}
            </td>
        );
    }

    getPlayerExposureHead() {
        const {usedPlayers} = this.props;
        const players = usedPlayers.all();
        const isOriginExposureUsed = !isEmpty(players) && 'lateSwapLineupsUsage' in players[0];

        return <th>{isOriginExposureUsed ? 'Orig/Exp%' : 'Exp%'}</th>;
    }

    getPlayersNotFoundView(params) {
        const {colSpan, className = 'emtpy'} = params;

        return (
            <tr key="players-not-found" className={className}>
                <td colSpan={colSpan}>Players were not found.</td>
            </tr>
        );
    }

    getTBodyPlayersNotFoundView(params) {
        const {colSpan} = params;

        return (
            <tbody key="players-not-found">
                <tr>
                    <td colSpan={colSpan}>Players were not found.</td>
                </tr>
            </tbody>
        );
    }

    wrapContentInTooltip(content, tooltipSubject) {
        const contentWithTooltip = React.cloneElement(content, {tooltipSubject});

        return <>{contentWithTooltip}</>;
    }
}

export {PlayersList};
